<div.search-container>
    <div>
        <app-search-form ...input on-search("handleSearch")/>
    </div>
    <div>
        <app-search-result ...state.searchResult/>
    </div>
    <loading-text />
</div>